import styled from 'styled-components';

export default function PointInput(props) {
  const { value, setValue } = props;

  // 입력값 변경시 //
  function onChangeInput(e) {
    const regex = /[^0-9]/g;
    const result = e.target.value.replace(regex, "");
    setValue(result === '' ? 0 : parseInt(result));
  }

  return (
    <TopLevelWrapper>
      <TopWrapper>
        <LeftWrapper>
          <Input
            placeholder={0}
            value={value}
            onChange={onChangeInput} />
        </LeftWrapper>
        <Text
          fontFamily='NotoSansKR-Medium'
          fontSize={14}
          color='#CBCBCB'>
          POINT
        </Text>
      </TopWrapper>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  transition: all 0.3s ease-in-out;
`;

const TopWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 10px;
`;

const LeftWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 8px;
`;

const Input = styled.input`
  display: flex;
  flex-direction: row;

  align-items: center;

  width: 53px;
  height: 30px;

  border: 1px solid #DFDFDF;
  border-radius: 8px;
  background-color: #FFFFFF;

  padding: 0 8px 0 8px;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: #000000;

  ::placeholder {
    color: #CBCBCB;
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;
`;
